import React from 'react';
import { Container, Content } from './styles';
import { Spinner } from 'ui-components/src';

export const Skeleton = () => (
  <Container>
    <Content>
      <Spinner />
    </Content>
  </Container>
);
